<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5>Editar Conta Empresa</h5>
            <form #f="ngForm" name="form" novalidate>
                <div class="formgroup" *ngIf="planoContaEmpresa">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-5">
                            <label htmlFor="descricao">Descrição da Conta</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Digite a descrição"
                                name="descricao"
                                ngModel
                                #descricao="ngModel"
                                required
                                [(ngModel)]="planoContaEmpresa.descricao"
                            />
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-7">
                            <label htmlFor="especificacao">Especificação</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Digite a especificação"
                                name="especificacao"
                                ngModel
                                #especificacao="ngModel"
                                required
                                [(ngModel)]="planoContaEmpresa.especificacao"
                            />
                            <div
                                *ngIf="especificacao.hasError('required') && especificacao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="dre">DRE</label>
                            <p-dropdown
                                [options]="categoriasDre"
                                [filter]="true"
                                placeholder="Selecione"
                                name="dre"
                                ngModel
                                #dre="ngModel"
                                [required]="true"
                                [(ngModel)]="planoContaEmpresa.dre"
                            ></p-dropdown>
                            <div *ngIf="dre.hasError('required') && dre.touched" class="alerta">
                                <small>Campo obrigatório</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="planoContaGrupo">Grupo</label>
                            <p-dropdown
                                [options]="planosContaGrupos"
                                optionLabel="descricao"
                                [filter]="true"
                                placeholder="Selecione"
                                name="planoContaGrupo"
                                ngModel
                                #planoContaGrupo="ngModel"
                                [required]="true"
                                [(ngModel)]="planoContaEmpresa.planoContaGrupo"
                            ></p-dropdown>
                        </div>
                        <div
                            class="field col-12 md:col-3"
                            *ngIf="planoContaEmpresa.planoContaGrupo?.id === 3"
                        >
                            <label htmlFor="utilizacao">Utilização</label>
                            <p-dropdown
                                [options]="utilizacoes"
                                placeholder="Selecione"
                                name="utilizacao"
                                ngModel
                                #utilizacao="ngModel"
                                [(ngModel)]="planoContaEmpresa.utilizacao"
                            ></p-dropdown>
                        </div>
                        <div
                            class="field col-12 md:col-2"
                            *ngIf="planoContaEmpresa.planoContaGrupo?.id === 3"
                        >
                            <label htmlFor="referenciaFolha">Referência Folha</label>
                            <p-dropdown
                                [options]="referenciasFolha"
                                placeholder="Selecione"
                                name="referenciaFolha"
                                ngModel
                                #referenciaFolha="ngModel"
                                [(ngModel)]="planoContaEmpresa.referenciaFolha"
                            ></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-1">
                            <label for="ativo">Ativo?</label>
                            <br />
                            <p-inputSwitch
                                name="ativo"
                                [(ngModel)]="planoContaEmpresa.ativo"
                            ></p-inputSwitch>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="configuravel">Configurável</label>
                            <br />
                            <p-inputSwitch
                                name="configuravel"
                                [(ngModel)]="planoContaEmpresa.configuravel"
                            ></p-inputSwitch>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                class="p-button-success mt-5"
                                [disabled]="!f.valid"
                                (click)="atualizar()"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-spin pi-spinner"
                                label="Atualizando..."
                                class="p-button-success mt-5"
                                [disabled]="true"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-8"></div>
                        <div class="field col-12 md:col-2">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-primary mt-5"
                                (click)="voltar()"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
